import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tank-stage-pfms-import',
  templateUrl: './tank-stage-pfms-import.component.html',
  styleUrls: ['./tank-stage-pfms-import.component.scss']
})
export class TankStagePfmsImportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
